import FormValidation from '../common/form-validation';

// Sign in & Sign up forms
new FormValidation('#new_tenant', {
  'tenant[email]': {
    presence: true,
    email: true
  },
  'tenant[password]': {
    presence: true,
    length: {
      minimum: 6
    }
  }
})

// Forgot password form
const forgotPassword = new FormValidation('#form_forgot_password', {
  'tenant[email]': {
    presence: true,
    email: true
  }
})

$(forgotPassword.form).on('ajax:success', (e) => {
  $(e.target).closest('.panel').html( $('#email_sent_text').html() );
});

// New password form
new FormValidation('#form_new_password', {
  'tenant[password]': {
    presence: true,
    length: {
      minimum: 6
    }
  },
  'tenant[password_confirmation]': {
    presence: true,
    equality: 'tenant[password]',
    length: {
      minimum: 6
    }
  }
})

// Sign up form for early access
const earlyAccess = new FormValidation('.form-early-access', {
  'early_access[name]': {
    presence: true
  },
  'early_access[email]': {
    presence: true,
    email: true
  }
})

$(earlyAccess.form).on('ajax:success', (e) => {
  $(e.target).find(':input:visible').val('');
  const message = $('<div />').addClass('alert alert-success').text('Thank you for signing up! We have received your details and will notify you of our upcoming launch shortly.');
  $('.form-early-access').append(message)
});



// WEBPACK FOOTER //
// app/javascript/frontend/devise.js